// extracted by mini-css-extract-plugin
export var button = "_kk-0";
export var donut = "_kk-1";
export var donutFill = "_kk-3";
export var donutTrack = "_kk-2";